import Config from "~/config";
import { normalizeHost } from "~portal/helpers/hostClassification";

const CANONICAL_PORTAL_LABEL = "auth";
const PRODUCTION_PORTAL_APEX = "portal.silverfern.com";
const NON_PRODUCTION_PORTAL_APEX = "portal.silverfern.red";

export const CANONICAL_PORTAL_LOGIN_PATH = "/portal-login";
export const PORTAL_SESSION_HANDOFF_PATH = "/session-handoff";

export const resolveCanonicalPortalHost = (environment: string): string =>
	`${CANONICAL_PORTAL_LABEL}.${environment === "production" ? PRODUCTION_PORTAL_APEX : NON_PRODUCTION_PORTAL_APEX}`;

const canonicalPortalHost = (): string => resolveCanonicalPortalHost(Config.environment);

export const isCanonicalPortalHost = (host: string): boolean => normalizeHost(host) === canonicalPortalHost();

export const buildCanonicalPortalLoginUrl = (encodedHandoffState: string): string => {
	const params = new URLSearchParams({ portalHandoff: encodedHandoffState });
	return `https://${canonicalPortalHost()}${CANONICAL_PORTAL_LOGIN_PATH}?${params.toString()}`;
};

export const buildPortalSessionHandoffUrl = (targetDomain: string, handoffCode: string): string => {
	const params = new URLSearchParams({ code: handoffCode });
	return `https://${normalizeHost(targetDomain)}${PORTAL_SESSION_HANDOFF_PATH}?${params.toString()}`;
};

export default canonicalPortalHost;
